import { render, staticRenderFns } from "./showDetail.vue?vue&type=template&id=861b508e&scoped=true"
import script from "./showDetail.vue?vue&type=script&lang=js"
export * from "./showDetail.vue?vue&type=script&lang=js"
import style0 from "./showDetail.vue?vue&type=style&index=0&id=861b508e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861b508e",
  null
  
)

export default component.exports